import { FunnelConfig } from '~/utils/funnels';

export const config: FunnelConfig = {
  id: 'nonABP',
  path: '/go-illinois',
  show: () => true,
};
